import activist from './activist.svg'
import admin from './admin.svg'
import doctor from './doctor.svg'
import flagJP from './flag_jp.svg'
import flagKr from './flag_kr.svg'
import flagOther from './flag_other.svg'

const icon = { activist, admin, doctor, flagJP, flagKr, flagOther }

export default icon
